module.exports = __webpack_public_path__ + "img/hof_1.a191b2da.jpg";